class FilterTabs {
  constructor(sectionId) {
    this.sectionId = sectionId
    this.wrapper = document.querySelector(`[data-section-id="${sectionId}"]`)
    this.activeFilters = this.wrapper.querySelector("#activeFilters")
    this.filterButtons = this.wrapper.querySelectorAll(".filter-button")
    this.dropdownMenus = this.wrapper.querySelectorAll(".dropdown-menu")
    this.currentFilters = new Map()
    this.currentCollection = this.getCurrentCollection()

    this.init()
  }

  getCurrentCollection() {
    // Get current collection from URL or data attribute
    const pathSegments = window.location.pathname.split("/").filter((segment) => segment)
    if (pathSegments.includes("collections") && pathSegments.length > 1) {
      const collectionIndex = pathSegments.indexOf("collections")
      return pathSegments[collectionIndex + 1] || "default"
    }
    return "default"
  }

  init() {
    this.parseUrlFilters()
    this.bindEvents()
    this.updateActiveFiltersDisplay()
    this.closeDropdownsOnClickOutside()
  }

  parseUrlFilters() {
    const urlParams = new URLSearchParams(window.location.search)
    const pathSegments = window.location.pathname.split("/").filter((segment) => segment)

    // Parse filters from URL parameters and path
    urlParams.forEach((value, key) => {
      if (key.startsWith("filter_")) {
        const filterType = key.replace("filter_", "")
        this.currentFilters.set(filterType, {
          value: value,
          display: this.capitalizeFirst(value.replace(/-/g, " ")),
        })
      }
    })

    // Parse collection-specific filters from path
    if (pathSegments.includes("collections")) {
      const collectionIndex = pathSegments.indexOf("collections")
      if (pathSegments[collectionIndex + 1]) {
        const collectionHandle = pathSegments[collectionIndex + 1]
        this.inferFiltersFromCollection(collectionHandle)
      }
    }
  }

  inferFiltersFromCollection(collectionHandle) {
    // Enhanced collection mappings with collection-specific logic
    const collectionMappings = {
      // Birthday Cakes specific
      "birthday-gifts-men": { type: "recipient", display: "Men", collection: "birthday-gifts" },
      "birthday-gifts-women": { type: "recipient", display: "Women", collection: "birthday-gifts" },
      "birthday-gifts-kids": { type: "recipient", display: "Kids", collection: "birthday-gifts" },

      // Flowers specific
      "flowers-men": { type: "recipient", display: "Men", collection: "flowers" },
      "flowers-women": { type: "recipient", display: "Women", collection: "flowers" },
      "flowers-kids": { type: "recipient", display: "Kids", collection: "flowers" },

      // Personalized specific
      "personalized-men": { type: "recipient", display: "Men", collection: "personalized" },
      "personalized-women": { type: "recipient", display: "Women", collection: "personalized" },
      "personalized-kids": { type: "recipient", display: "Kids", collection: "personalized" },

      // Generic mappings
      men: { type: "recipient", display: "Men" },
      women: { type: "recipient", display: "Women" },
      kids: { type: "recipient", display: "Kids" },
      birthday: { type: "occasion", display: "Birthday" },
      anniversary: { type: "occasion", display: "Anniversary" },
      wedding: { type: "occasion", display: "Wedding" },
      husband: { type: "relationship", display: "Husband" },
      father: { type: "relationship", display: "Father" },
      son: { type: "relationship", display: "Son" },
    }

    if (collectionMappings[collectionHandle]) {
      const mapping = collectionMappings[collectionHandle]
      this.currentFilters.set(mapping.type, {
        value: collectionHandle,
        display: mapping.display,
      })
    }
  }

  bindEvents() {
    // Dropdown toggle events
    this.filterButtons.forEach((button) => {
      button.addEventListener("click", (e) => {
        e.preventDefault()
        e.stopPropagation()
        this.toggleDropdown(button)
      })
    })

    // Option selection events
    this.wrapper.querySelectorAll(".dropdown-option").forEach((option) => {
      option.addEventListener("click", (e) => {
        e.preventDefault()
        this.handleOptionSelect(option)
      })
    })
  }

  toggleDropdown(button) {
    const dropdown = button.nextElementSibling
    const isActive = button.classList.contains("active")

    // Close all dropdowns
    this.closeAllDropdowns()

    if (!isActive) {
      button.classList.add("active")
      dropdown.classList.add("active")
    }
  }

  closeAllDropdowns() {
    this.filterButtons.forEach((btn) => btn.classList.remove("active"))
    this.dropdownMenus.forEach((menu) => menu.classList.remove("active"))
  }

  closeDropdownsOnClickOutside() {
    document.addEventListener("click", (e) => {
      if (!this.wrapper.contains(e.target)) {
        this.closeAllDropdowns()
      }
    })
  }

  handleOptionSelect(option) {
    const filterType = option.closest(".filter-dropdown").dataset.filterType
    const filterValue = option.dataset.filterValue
    const filterDisplay = option.dataset.filterDisplay
    const collectionUrl = option.dataset.collectionUrl
    const currentCollection = option.dataset.currentCollection

    // Update current filters
    this.currentFilters.set(filterType, {
      value: filterValue,
      display: filterDisplay,
    })

    // Navigate to the collection URL with filters
    this.navigateWithFilters(collectionUrl)
  }

  navigateWithFilters(baseUrl) {
    const url = new URL(baseUrl, window.location.origin)

    // Add current filters as URL parameters
    this.currentFilters.forEach((filter, type) => {
      url.searchParams.set(`filter_${type}`, filter.value)
    })

    window.location.href = url.toString()
  }

  updateActiveFiltersDisplay() {
    this.activeFilters.innerHTML = ""

    this.currentFilters.forEach((filter, type) => {
      const filterTag = this.createFilterTag(type, filter)
      this.activeFilters.appendChild(filterTag)
    })
  }

  createFilterTag(type, filter) {
    const tag = document.createElement("div")
    tag.className = "filter-tag"
    tag.innerHTML = `
      <span>${filter.display}</span>
      <svg class="remove-icon" width="16" height="16" viewBox="0 0 16 16" fill="currentColor">
        <path d="M12.854 4.854a.5.5 0 0 0-.708-.708L8 8.293 3.854 4.146a.5.5 0 1 0-.708.708L7.293 9l-4.147 4.146a.5.5 0 0 0 .708.708L8 9.707l4.146 4.147a.5.5 0 0 0 .708-.708L8.707 9l4.147-4.146z"/>
      </svg>
    `

    // Add click event for removal
    const removeIcon = tag.querySelector(".remove-icon")
    removeIcon.addEventListener("click", (e) => {
      e.preventDefault()
      this.removeFilter(type)
    })

    return tag
  }

  removeFilter(filterType) {
    this.currentFilters.delete(filterType)

    // Navigate to appropriate URL based on current collection
    if (this.currentFilters.size === 0) {
      // Redirect to main collection page
      const mainCollectionUrl = this.getMainCollectionUrl()
      window.location.href = mainCollectionUrl
    } else {
      // Navigate to the most specific remaining filter
      const remainingFilter = Array.from(this.currentFilters.values())[0]
      const baseUrl = this.getCollectionUrlForFilter(remainingFilter.value)
      this.navigateWithFilters(baseUrl)
    }
  }

  getMainCollectionUrl() {
    // Return to the main collection page based on current collection
    const collectionMappings = {
      "birthday-cakes": "/collections/birthday-cakes",
      flowers: "/collections/flowers",
      personalized: "/collections/personalized",
      "corporate-gifts": "/collections/corporate-gifts",
      anniversary: "/collections/anniversary",
      wedding: "/collections/wedding",
      valentines: "/collections/valentines",
      christmas: "/collections/christmas",
      "mothers-day": "/collections/mothers-day",
      "fathers-day": "/collections/fathers-day",
    }

    return collectionMappings[this.currentCollection] || "/collections"
  }

  getCollectionUrlForFilter(filterValue) {
    // Map filter values back to collection URLs based on current collection context
    const baseCollection = this.currentCollection

    if (baseCollection && baseCollection !== "default") {
      return `/collections/${baseCollection}-${filterValue}`
    }

    // Fallback to generic URLs
    const urlMappings = {
      men: "/collections/men",
      women: "/collections/women",
      kids: "/collections/kids",
      birthday: "/collections/birthday",
      anniversary: "/collections/anniversary",
      wedding: "/collections/wedding",
      husband: "/collections/husband",
      father: "/collections/father",
      son: "/collections/son",
    }

    return urlMappings[filterValue] || "/collections"
  }

  capitalizeFirst(str) {
    return str.charAt(0).toUpperCase() + str.slice(1)
  }
}

// Auto-initialize on page load
document.addEventListener("DOMContentLoaded", () => {
  // Initialize all filter tab sections
  document.querySelectorAll("[data-section-id]").forEach((section) => {
    const sectionId = section.dataset.sectionId
    if (section.classList.contains("filter-tabs-wrapper") || section.querySelector(".filter-tabs-wrapper")) {
      new FilterTabs(sectionId)
    }
  })
})
